import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { API } from "../config/api-config";
import { CommonService } from "../service/common";
import { FileUpload } from "../service/file-upload";
import { Location } from "@angular/common";
import { HttpService } from "../service/http-service";

declare var alertify: any;

@Component({
  selector: "app-share-product-edit",
  templateUrl: "./share-product-edit.component.html",
  styleUrls: ["./share-product-edit.component.css"],
})
export class ShareProductEditComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private HttpService: HttpService,
    private location: Location,
    private fileupload: FileUpload,
    private common: CommonService
  ) {}

  private id: number = 0;

  public isCreate: boolean = false;

  public imagePath: string = "";

  private tempPath: string = API.getTemp;

  public data: any = {
    id: 0,
    active: 1,
    name: "",
    ranks: 0,
    openShare: false,
    shareDetailUrl: "",
    shareImage: "",
    shareNotice: "",
    shareUrl: "",
    shareDetailType: 1,
    shareContent: "",
  };

  ngOnInit() {
    this.getPath();
    this.route.params.subscribe((params) => {
      this.id = params["id"];
      this.data.id = this.id;
    });
    if (this.id != 0) {
      this.getData();
    } else {
      this.isCreate = true;
    }
  }
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    // let editor = window["CKEDITOR"];
    // if (editor.instances) {
    //   for (var editorInstance in editor.instances) {
    //     editor.instances[editorInstance].destroy();
    //   }
    // }
  }

  public submit(): void {
    const data = this.data;
    if (this.id != 0) {
      data.id = this.id;
    } else {
      delete data.id;
    }
    delete data.createdBy;
    delete data.createdTime;
    delete data.updatedBy;
    delete data.updatedTime;

    this.HttpService.postData(API.shareProduct, data).then((res) => {
      let data = res;
      if (data.status.code == 0 || data.status.code == "0") {
        this.location.back();
      } else {
        alert(data.status.message);
      }
    });
  }

  private getData(): void {
    this.HttpService.getData(API.shareProduct + "/" + this.id).then((res) => {
      this.data = res.data;
    });
  }

  public showimage = false;
  public showimageTc = false;

  private upload(name: string) {
    let self = this;
    this.fileupload.upload(function (res) {
      let temRes = JSON.parse(res);
      if (temRes.status.code == 0) {
        switch (name) {
          case "shareImage":
            self.showimage = true;
            break;
        }
        self.data[name] = temRes.data.fileName;
      } else {
        alertify.error(temRes.status.message);
      }
    });
  }

  private getPath(): void {
    this.HttpService.getData(API.resourcePath).then((res) => {
      this.imagePath = res.data;
    });
  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/share-product-edit/share-product-edit.component.ts